const config = {
	apiKey: "AIzaSyDuAwVlbpt1m7kE6NjXnBSiihfWWcdcZPM",
	authDomain: "veolia-xmas.firebaseapp.com",
	databaseURL: "https://veolia-xmas.firebaseio.com",
}

export default config;
